import DesktopSerpFilters from './ui/serpFilters/DesktopSerpFilters.vue';

export {
    DesktopSerpFilters,
};